import { C } from '../../lib/theme';
import { styles } from '../../lib/styles';
import { $ } from '../../lib/util';
import { Dialog } from '../Dialog';
import { useUIState } from '../../state/contexts/UIStateContext';
import { useDisputeActions } from '../../state/actions/disputes';

export function IpCounterClaimModal() {
  const { setModal, setModalData, modalData } = useUIState();
  const { respondIpDispute } = useDisputeActions();
  return (
    <Dialog title="Log Registrant Counter-Claim" onClose={() => setModal(null)}>
        <div style={{ fontSize: 13, color: C.textMuted, marginBottom: 16 }}>Registrant is contesting the IP infringement claim. Counter-claim will be forwarded to the claimant. For copyright claims, content may be reinstated after 10-14 business days unless the claimant files a court action.</div>
        <div style={{ marginBottom: 16 }}>
          <label htmlFor="ip-counter-text" style={{ fontSize: 11, color: C.textMuted }}>Counter-Claim Details</label>
          <textarea id="ip-counter-text" style={styles.textarea} placeholder="Describe the basis for the counter-claim, proof of rights, or authorization..." />
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <button style={{ ...styles.btn, ...styles.btnGold }} onClick={() => {
            const text = $('ip-counter-text').value;
            if (text) { respondIpDispute(modalData.caseId, modalData.disputeId, text); setModal(null); setModalData({}); }
          }}>File Counter-Claim</button>
          <button style={{ ...styles.btn, ...styles.btnOutline }} onClick={() => { setModal(null); setModalData({}); }}>Cancel</button>
        </div>
    </Dialog>
  );
}
